import { GameModel } from "yage/game/GameModel";

export const getOwner = (entity: number, gameModel: GameModel): number => {
  if (gameModel.hasComponent(entity, "Owner") && gameModel.getComponent(entity, "Owner")?.owner != null) {
    return getOwner(gameModel.getComponentUnsafe(entity, "Owner").owner!, gameModel);
  }
  return entity;
};
